module.exports = __webpack_public_path__ + "img/marketing_es@2x.a1502d32.png";